@if (view(); as v) {
  <div
    data-testid="plan-edit-banner"
    role="status"
    class="border-default bg-surface flex shrink-0 flex-wrap items-center gap-x-2 gap-y-1 rounded-sm border py-1 pr-1 pl-2.5 text-xs shadow-[inset_2px_0_0_var(--color-warning)]">
    <i [class]="ICONS.lock + ' text-warning shrink-0 text-sm'" aria-hidden="true"></i>
    <span
      data-testid="plan-edit-banner-text"
      class="text-text-primary min-w-0 flex-1 font-medium">
      {{ textKey() | translate: { name: v.name } }}
    </span>
    @if (v.timings) {
      <span
        data-testid="plan-edit-banner-timings"
        class="text-text-secondary inline-flex shrink-0 items-center gap-1">
        @if (v.timings === 'recomputing') {
          <i [class]="ICONS.arrowsClockwise + ' animate-spin'" aria-hidden="true"></i>
        }
        {{ 'features.plan.edit.banner.timings.' + v.timings | translate }}
      </span>
    }
    @if (v.assistantHold) {
      <div class="inline-flex shrink-0 items-center gap-1">
        <app-button
          [icon]="ICONS.sparkle"
          [label]="'features.plan.edit.banner.open_chat' | translate"
          [type]="'transparent'"
          [size]="'sm'"
          (clickEvent)="openChat()" />
        <button
          type="button"
          data-testid="plan-edit-banner-discard"
          class="text-danger hover:bg-danger-soft hover:text-danger-hover cursor-pointer rounded-sm px-2 py-1 font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-60"
          [disabled]="discarding()"
          (click)="discard()">
          {{ 'features.plan.edit.banner.discard' | translate }}
        </button>
      </div>
    }
  </div>
}
